// extracted by mini-css-extract-plugin
module.exports = {"setting":"Option--setting--3bV72","label":"Option--label--1MHcL","description":"Option--description--30qeX","title":"Option--title--gVj6j","detail":"Option--detail--fdG_I"};